/**
 * https://github.com/wendux/fly/blob/master/README-CH.md
 */
import axios from 'axios';
import qs from 'qs';
import store from '../store';
const http = axios.create({
    timeout: 20000,
    responseType: 'json',
    withCredentials: true, // 是否允许带cookie这些
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    transformResponse: [function (data) {
        if (typeof data === 'string') {
            data = JSON.parse(data);
        }
        return data;
    }]
});

http.interceptors.request.use((request) => {
        let params = {};
        if (!request.noToken) {
            params['token'] = store.state.token || undefined;
        }
        params['COMPANYID'] = store.state.companyId || undefined;
        request.url = request.url + '?' + qs.stringify(params);
        console.log('---token---', store, store.state, request, qs.stringify(params));
    return request;
});


export default http;

